import Link from "next/link";
import { useTranslations } from "next-intl";
import useRedirectToBlog from "@/hooks/common/useRedirectToBlog";
import { FaFacebookSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { helpCenterLink } from "@/constant";
import classes from "./Footer.module.scss";
interface Props {
  title?: {
    vcard: string;
    socialMedia: string;
    pdf: string;
  };
  footerTitle?: string;
}
const Footer = ({
  title,
  footerTitle
}: Props) => {
  const t = useTranslations("Footer");
  const {
    handleClick
  } = useRedirectToBlog();
  return <div className={classes.Wrapper} data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <div className={classes.Container}>
        <div className={classes.TopFooter}>
          <div className={classes.TopRow}>
            <div className={classes.MenuBox}>
              <div className={classes.MenuGroup}>
                <p className={classes.Title}>{t("solutions")}</p>
                <Link href={"/"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{footerTitle ? footerTitle : t("qrCodeCreator")}</Link>
                <Link href={"/solutions"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{t("qrcodeType")}</Link>
                <Link href={"/pricing"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{t("pricing")}</Link>
                <Link href={"/qr-api"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{t("api")}</Link>
              </div>
              <div className={classes.MenuGroup}>
                <p className={classes.Title}>{t("qrCodes")}</p>
                <div onClick={() => handleClick("vcard", "vcard-qr-code")} className={classes.redirect_link}>
                  {title ? title.vcard : t("qrForVCard")}
                </div>
                <div onClick={() => handleClick("socialmedia", "social-media-qr-code")} className={classes.redirect_link}>
                  {title ? title.socialMedia : t("qrForSocialMedia")}
                </div>
                <div onClick={() => handleClick("pdf", "/pdf-qr-code")} className={classes.redirect_link}>
                  {title ? title.pdf : t("qrForPdf")}
                </div>
              </div>
              <div className={classes.MenuGroup}>
                <p className={classes.Title}>{t("support")}</p>
                <Link href={helpCenterLink} target={"_blank"} rel="noreferrer" className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">
                  {" "}
                  {t("helpCenter")}
                </Link>
                <Link href={"/terms"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{t("termsConditions")}</Link>
                <Link href={"/policy"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{t("privacy")}</Link>
              </div>
              <div className={classes.MenuGroup}>
                <p className={classes.Title}>{t("company")}</p>
                <Link href={"/about"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{t("aboutUs")}</Link>
                <Link href={"/contact"} className={classes.redirect_link} data-sentry-element="Link" data-sentry-source-file="Footer.tsx">{t("contactUs")}</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.BottomFooter}>
        <div className={classes.Container}>
          <div className={classes.BottomRow}>
            <p className={classes.Copyright}>
              {new Date().getFullYear()} © qrcodecreator.com, {t("copywrite")}
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default Footer;